<!--
 * @Author: zh
 * @Date: 2024-10-25 09:20:05
 * @LastEditors: zh
 * @LastEditTime: 2024-10-25 09:20:05
 * @Description: 维保计划待处理列表
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-60 o-dialog--lg-60 o-dialog--xl-60 o-dialog-h--75"
    title="维保计划待处理列表"
    :visible.sync="dialogShow"
    :show-close="false"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <div
      slot="title"
      class="dialog-footer"
    >
      <span>维保计划待处理列表</span>
      <div class="dev-gb">
        <el-button
          icon="kestrel-icon ki-close"
          @click="closeDialog()"
        >
          关闭弹窗
        </el-button>
      </div>
    </div>
    <div class="l-page--inner l-page--search">
      <el-form
        ref="filterParams"
        class="c-form c-condition__form u-mg-b-10"
        :model="filterParams"
        :inline="true"
        label-position="right"
        label-suffix="："
      >
        <el-row class="c-form__row">
          <el-col
            class="c-form__col"
            :span="5"
          >
            <el-form-item
              class="c-form__item"
              label="计划名称"
              prop="jhmc"
            >
              <el-input
                v-model.trim="filterParams.jhmc"
                class="c-form__input"
                placeholder="请输入计划名称"
                clearable
                maxlength="100"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="2"
          >
            <el-form-item class="c-form__item">
              <el-button
                style="margin-left: 10px;"
                type="primary"
                icon="kestrel-icon ki-search"
                @click="refreshSearch()"
              >
                查询
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        class="l-page__body l-page--search__body"
        style="display: flex; margin: 0;"
      >
        <!-- 查询条件 End -->
        <k-table
          ref="kTable"
          height="100%"
          :table-column="tableColumn"
          :data="page.rows"
          :pagination="page"
          @current-change="search"
          @size-change="handleSizeChange"
        >
          <template #xmmc="scope">
            <el-link
              type="primary"
              @click="toWbxmDetail(scope.row)"
            >
              {{ scope.row.xmmc }}
            </el-link>
          </template>
          <template #jhmc="scope">
            <el-link
              type="primary"
              @click="toWbjhDetail(scope.row)"
            >
              {{ scope.row.jhmc }}
            </el-link>
          </template>
          <template #qzrq="scope">
            {{ scope.row.jhsjQ || '-' | date("yyyy-MM-dd ") }} 至 {{ scope.row.jhsjZ|| '-' | date("yyyy-MM-dd ") }}
          </template>
        </k-table>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { wbjhService } from '../xfwbgl/wbjh/wbjh.service.js';
export default {
  name: 'WksWbjh',
  props: {
    wksWbjhIdList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      dialogShow: true, // 模态框dialog显示
      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        sjssbmDm: null,
        jhzt: 'WKS',
        xmmc: null,
        jhmc: null,
        uuids: [],
        jhkssjz: null // 计划开始时间止
      },
      /* 查询条件 end */

      /* 弹窗 start */
      dialogParams: {},
      /* 弹窗 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */
      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', slotName: 'xmmc', label: '项目名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'jhmc', slotName: 'jhmc', label: '计划名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'qzrq', slotName: 'qzrq', label: '计划起止日期', align: 'center', width: '200', type: 'date' },
        { key: 'jhztMc', label: '计划状态', align: 'center', width: '80', type: 'text' },
        { key: 'cjsj', label: '创建时间', align: 'center', width: '140', type: 'dateTime' }
      ]
      /* 表格列配置End */
    };
  },
  methods: {
    toWbxmDetail (row) {
      this.$emit('closeDialog', '');
      this.openNavTab({ name: 'viewWbxm', params: { xmId: row.xmId } });
    },
    toWbjhDetail (row) {
      this.$emit('closeDialog', '');
      this.openNavTab({ name: 'viewWbjh', params: { id: row.id } });
    },
    // 用户信息
    currentUser () {
      return this.$HMStoreService.getUserinfo();
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;
      const nowMonth = new Date().getMonth();
      const nowYear = new Date().getFullYear();
      const lastDay = new Date(nowYear, nowMonth + 1, 0).getDate();
      const lastDayTime = new Date(nowYear, nowMonth, lastDay).getTime();
      this.trueFilterParams.jhkssjz = lastDayTime;
      if (this.wksWbjhIdList.length > 0) {
        this.trueFilterParams.uuids = this.wksWbjhIdList;
      }
      wbjhService.query(this.trueFilterParams).then(rsp => {
        this.page = Object.assign({}, this.page, rsp.data);
      }).catch(err => {
        console.error('查询错误！', err);
      }).finally(() => {
        this.loading = false;
      });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    }
  },
  created () {
    this.filterParams.sjssbmDm = this.currentUser().dept.deptCode;
    this.refreshSearch();
  },
  activated () {
  }
};
</script>
<style lang="scss">
.dialog-footer {
  display: flex;
  width: 100%;
  font-size: 18px;
}

.dev-gb{
  position: absolute;
  right: 5px;
}

.dev-table-content{
  display: flex;
  flex-direction: row;
}

.dev-table-hide{
  width: 60% !important;
}
</style>
